/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import {
  triageChallengeSchema,
  triageClipSchema,
} from '../getCollectionTriageNext/get-collection-triage-next-response';

export const navigateTriageItemSchema = z
  .object({
    clip: triageClipSchema,
    challenge: triageChallengeSchema,
  })
  .nullable();

export const navigateCollectionTriageClipResponseSchema = createApiResponseSchema(
  navigateTriageItemSchema,
) as z.ZodSchema<IAPI<INavigateTriageItem | null>>;

export interface INavigateTriageClip {
  id: number;
  baseLocalPath: string | null;
  verticalLocalPath?: string | null;
  basePath: string | null;
  verticalPath: string | null;
  cropStatus: string | null;
  vaultPath: string | null;
  startMs: number | null;
  endMs: number | null;
  triageAction: string | null;
  rejectionReason: string | null;
  fileSizeKb: number | null;
  subtitleEntries: unknown[] | null;
}

export interface INavigateTriageChallenge {
  id: number;
  title: string | null;
  definition: string | null;
  definitionSimple: string | null;
  published: number;
  triageStatus: string | null;
}

export interface INavigateTriageItem {
  clip: INavigateTriageClip;
  challenge: INavigateTriageChallenge;
}

export type INavigateCollectionTriageClipResponse = IAPI<INavigateTriageItem | null>;
